import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgFilterHopperSolid = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4.07 5.79a.964.964 0 0 1 .867-.54h10.125c.352 0 .68.21.844.54a.984.984 0 0 1-.14 1.007L11.5 12.023V15a.73.73 0 0 1-.422.68.809.809 0 0 1-.797-.07l-1.5-1.126c-.187-.14-.281-.351-.281-.609v-1.852L4.21 6.797a.984.984 0 0 1-.14-1.008Z"
        fill="#374151"
      />
    </svg>
  );
};
export default SvgFilterHopperSolid;
